<template>
  <v-card>
    <h1 class="text-pagename text-xs-center">Hub</h1>
    <hubTable/>
  </v-card>
</template>

<script>
import hubTable from "@/components/back-office/Rider/Hub/HubTable";
export default {
  data() {
    return {};
  },
  components: {
    hubTable
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Rider",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/rider/riderdashboard"
      },
      {
        text: "Hub management",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>
